<template>
  <div class="box">
    <div v-for="(item, index) in elementList" :key="index" class="element">
      <component
        :is="item"
        :element-data="elementData"
        :fund-code="fundCode"
        :trade-data="tradeData"
        :merge-data="mergeData"
        :product-seats-info="productSeatsInfo"
        :index-info="indexInfo"
        :basic-info="elementData"
        :detail-info="mergeData"
      />
    </div>
    <div class="risk-tip">
      <p class="tip-text"
        >非公募基金产品，本页面数据无公开渠道可供查询，我公司无法保证上述数据真实、准确、完整。请勿作为投资决策依据。</p
      >
    </div>
  </div>
</template>

<script>
// import { isEmpty } from '@fund/basic-lib/dist/lib/lang';
import BarAndQue from '@/components/Fund-BarAndQue.vue';
import FloatList from './FloatList.vue';
// import HighEndStrategyModule from './HighEndStrategyModule.vue';
// import HighEndRiskAndProfit from './HighEndRiskAndProfit.vue';
import HighEndArchives from './HighEndArchives.vue';
import HighEndBouns from './HighEndBouns.vue';
import HighEndChartView from './HighEndChartView.vue';
import HighEndNotice from './HighEndNotice.vue';
import HighEndTips from './HighEndTips.vue';
import HighEndTradeMustKnow from './HighEndTradeMustKnow.vue';
import HistoryNetList from './HistoryNetList.vue';
// import LiquidateNotice from './LiquidateNotice.vue';
import StageRiseList from './StageRiseList.vue';
// import OrganizeRecommendTip from './OrganizeRecommendTip.vue';
// import HighEndHoldModule from './holdModule/index.vue';

export default {
  props: {
    elementData: Object,
    fundCode: String,
    tradeData: Array,
    mergeData: Object,
    productSeatsInfo: Object,
    indexInfo: {
      default: () => {},
      type: Object,
    },
  },

  components: {
    HighEndChartView,
    HighEndBouns,
    HighEndNotice,
    HighEndArchives,
    StageRiseList,
    HistoryNetList,
    HighEndTradeMustKnow,
    BarAndQue,
    HighEndTips,
    FloatList,
    // OrganizeRecommendTip,
    // HighEndRiskAndProfit,
    // HighEndHoldModule,
    // LiquidateNotice,
    // HighEndStrategyModule,
  },

  computed: {
    elementList() {
      console.log('this.elementData?.isNewFund', this.productSeatsInfo);
      if (this.elementData?.isNewFund) {
        return [
          'HighEndTips',
          'HighEndBouns',
          'HighEndTradeMustKnow',
          'HighEndArchives',
          'HighEndNotice',
          'BarAndQue',
        ];
      }
      return [
        'HighEndChartView',
        'FloatList',
        'HighEndBouns',
        'HighEndTradeMustKnow',
        'HighEndArchives',
        'HighEndNotice',
        'BarAndQue',
        // 'HighEndRiskAndProfit',
        // 'StageRiseList',
        // 'HistoryNetList',
      ];
      // if (isEmpty(this.elementData)) { return []; }
      // if (this.elementData?.isNewFund) {
      //   return [
      //     'OrganizeRecommendTip',
      //     'HighEndTips',
      //     'HighEndStrategyModule',
      //     'HighEndBouns',
      //     'HighEndTradeMustKnow',
      //     'HighEndHoldModule',
      //     'HighEndArchives',
      //     'HighEndNotice',
      //     'DiscussAndQuestion',
      //   ];
      // }
      // if (this.elementData?.isFloatCurrency) {
      //   return [
      //     'OrganizeRecommendTip',
      //     'HighEndTips',
      //     'LiquidateNotice',
      //     'HighEndChartView',
      //     'HistoryNetList',
      //     'HighEndStrategyModule',
      //     'HighEndBouns',
      //     'HighEndTradeMustKnow',
      //     'HighEndHoldModule',
      //     'HighEndArchives',
      //     'HighEndNotice',
      //     'DiscussAndQuestion',
      //   ];
      // }
      // if (this.elementData?.isFixedProfit) {
      //   return [
      //     'OrganizeRecommendTip',
      //     'LiquidateNotice',
      //     'HighEndStrategyModule',
      //     'HighEndBouns',
      //     'HighEndTradeMustKnow',
      //     'HighEndHoldModule',
      //     'HighEndArchives',
      //     'HighEndNotice',
      //     'DiscussAndQuestion',
      //   ];
      // }
      // if (this.elementData?.isNetFixedProfit) {
      //   return [
      //     'OrganizeRecommendTip',
      //     'LiquidateNotice',
      //     'HighEndStrategyModule',
      //     'HighEndBouns',
      //     'HighEndTradeMustKnow',
      //     'HighEndHoldModule',
      //     'HighEndArchives',
      //     'HighEndNotice',
      //     'DiscussAndQuestion',
      //   ];
      // }
      // return [
      //   'OrganizeRecommendTip',
      //   'LiquidateNotice',
      //   'HighEndChartView',
      //   'FloatList',
      //   'HighEndRiskAndProfit',
      //   'HighEndStrategyModule',
      //   'HighEndBouns',
      //   'HighEndTradeMustKnow',
      //   'HighEndHoldModule',
      //   'HighEndArchives',
      //   'HighEndNotice',
      //   'DiscussAndQuestion',
      // ];
    },
  },
};
</script>

<style scoped>

.box {
  margin-top: 24px;
}

.risk-tip {
  width: 100%;
  justify-content: center;
  align-items: center;
  padding-top: 200px;
  padding-bottom: 600px;
}

.tip-text {
  font-size: 28px;
  color: #999999;
  text-align: center;
  line-height: 40px;
}
</style>
